import { render, staticRenderFns } from "./RequisitionBulkUpdateOwnerDialog.vue?vue&type=template&id=79ed7ae8&"
import script from "./RequisitionBulkUpdateOwnerDialog.vue?vue&type=script&lang=ts&"
export * from "./RequisitionBulkUpdateOwnerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports